import { ContactBoxContainer } from './styles';

export const ContactBox: React.FC = () => {
  return (
    <ContactBoxContainer>
      <div>
        <p>Não encontrou sua dúvida aqui?</p>
        <p>Entre em contato através do e-mail: contato@boratickets.com.br</p>
      </div>

      <a
        href="mailto:contato@boratickets.com.br"
        target="_blank"
        rel="noopener noreferrer"
      >
        Entre em contato
      </a>
    </ContactBoxContainer>
  );
};
